<style lang="scss" scoped>
// @import 'common/sass/reuse.SCSS';
.handle {
  margin: 25px;
  .trades {
    margin-left: 20px;
  }
  .handle-row {
    width: 100%;
  }
  .empty {
    padding: 20px;
  }
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 10px;
  width: 50%;
}
.el-select {
  width: 100%;
}
/deep/ .el-drawer__body {
  overflow-y: auto;
}
</style>

<template>
  <div class="maintenance-box">
    <div class="panel">
      <el-row class="handle">
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
          <el-button type="primary" class="handle-row" icon="el-icon-refresh" @click="refreshAcc">{{ reuse.refresh }}</el-button>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="trades">
          <el-button type="primary" class="handle-row" icon="el-icon-circle-plus" @click="addAccWindow = true">{{ language.addBtnTxt }}</el-button>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="trades">
          <el-badge :value="notifyCount">
            <el-button class="handle-row" :disabled="notifyCount === 0" @click="notify = true">{{ language.badgeBtnTxt }}</el-button>
          </el-badge>
        </el-col>
      </el-row>
      <el-row v-loading="loadAccInfo">
        <el-table :data="accInfo" border>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-form label-position="left" inline class="demo-table-expand">
                <template v-for="(v, i) in tableHead">
                  <el-form-item :label="v.value" :key="i">
                    <el-input v-if="v.writable" type="textarea" maxlength="255" show-word-limit v-model="scope.row[v.key]"></el-input>
                    <el-button v-else-if="v.table" type="text" @click="showTable(scope.row.LOGINS)">{{ language.showIPBtnTxt }}</el-button>
                    <span v-else>{{ scope.row[v.key] }}</span>
                  </el-form-item>
                </template>
              </el-form>
            </template>
          </el-table-column>
          <template v-for="(v, i) in accHead">
            <el-table-column :label="v.value" :key="i">
              <template slot-scope="scope">
                <el-input v-if="v.writable" type="textarea" maxlength="255" v-model="scope.row[v.key]"></el-input>
                <span v-else-if="v.redColor" :style="+scope.row[v.key] < 0 ? 'color:red;' : ''">{{ scope.row[v.key] }}</span>
                <span v-else>{{ scope.row[v.key] }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column :label="language.lastTableColumnTxt" width="120px">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" circle @click="deleteAccount(scope.row.LOGIN)"></el-button>
              <el-button type="primary" icon="el-icon-edit" circle @click="updateAccount(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row class="handle">
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
          <div class="empty"></div>
        </el-col>
        <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="9">
          <el-pagination
            :current-page="pageNum"
            :page-size="pageSize"
            :page-sizes="[5, 10, 25, 50]"
            :pager-count="5"
            :total="total"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <!-- 新增账户到监察名单 -->
    <el-dialog :title="language.addDialogTitle" :visible.sync="addAccWindow" :before-close="(done) => {}" :show-close="false">
      <el-form :model="accForm" :rules="rules" ref="accForm" label-position="top">
        <el-form-item :label="language.formLoginLabel" prop="login">
          <el-input v-model.number="accForm.login"></el-input>
        </el-form-item>
        <el-form-item :label="language.formCommentLabel" prop="comment">
          <el-select v-model="commentType" :placeholder="language.formSelectDefaultTxt" @change="handleCommentChange">
            <el-option v-for="(k, v) in language.commentOpt" :key="v" :label="k" :value="v"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="comment" v-if="commentType == 6">
          <el-input v-model="accForm.comment" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetAccInfo">{{ language.formCancelTxt }}</el-button>
        <el-button type="primary" @click="addAccount">{{ language.formConfirmTxt }}</el-button>
      </div>
    </el-dialog>
    <!-- ip关联账号的表格 -->
    <el-dialog :title="language.ipTableDialogTitle" :visible.sync="ipTableWindow" :close-on-click-modal="false" :close-on-press-escape="false" @close="handleWindowClose">
      <el-row :gutter="20">
        <el-col :lg="18" :md="18" :sm="18" :xl="18" :xs="18">
          <el-input v-model="keyword" :placeholder="language.ipTableKeywordTxt" @change="findByKeyword" />
        </el-col>
        <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="6">
          <el-button :disabled="this.allIps.length == 0" @click="export2Excel" style="width: 100%" type="primary">{{ reuse.downloadExcelForms }}</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-table :data="ipsData">
          <template v-for="(v, i) in language.ipTableHead">
            <el-table-column :property="v.key" :label="v.value" :key="i"></el-table-column>
          </template>
        </el-table>
      </el-row>
      <el-row class="handle">
        <el-col :lg="10" :md="10" :sm="10" :xl="10" :xs="10">
          <div class="empty"></div>
        </el-col>
        <el-col :lg="14" :md="14" :sm="14" :xl="14" :xs="14">
          <el-pagination
            :current-page="ipPageNum"
            :page-size="ipPageSize"
            :page-sizes="[5, 10, 25, 50]"
            :pager-count="5"
            :total="ipTotal"
            @current-change="handleIPPageChange"
            @size-change="handleIPSizeChange"
            layout="total, sizes, prev, pager, next"
          ></el-pagination>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 监察客户近期交易单明细列表 -->
    <el-drawer :visible.sync="notify" direction="rtl" size="50%" :with-header="false">
      <template v-for="(arr, k) in notifyData">
        <div v-if="arr != null" :key="k">
          <el-row class="handle">
            <el-col :lg="22" :md="22" :sm="22" :xl="22" :xs="22">
              <el-button type="text">{{ k }}</el-button>
            </el-col>
            <el-col :lg="2" :md="2" :sm="2" :xl="2" :xs="2">
              <el-button type="text" icon="el-icon-close" circle @click="clearNotify(k)"></el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-table :data="arr">
              <template v-for="(v, i) in language.tradesHead">
                <el-table-column v-if="v.key == 'CMD'" :label="v.value" :key="i" width="80px">
                  <template slot-scope="scope">
                    <span>{{ reuse.cmdMapping[scope.row[v.key]] }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="v.key == 'TIME'" :label="v.value" :key="i">
                  <template slot-scope="scope">
                    <span>{{ scope.row.CLOSE_TIME == '1970-01-01 00:00:00' ? scope.row.OPEN_TIME : scope.row.CLOSE_TIME }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="v.key == 'PRICE'" :label="v.value" :key="i">
                  <template slot-scope="scope">
                    <span>{{ scope.row.CLOSE_TIME == '1970-01-01 00:00:00' ? scope.row.OPEN_PRICE : scope.row.CLOSE_PRICE }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="v.key == 'TYPE'" :label="v.value" :key="i">
                  <template slot-scope="scope">
                    <span>{{ scope.row.CLOSE_TIME == '1970-01-01 00:00:00' ? language.open : language.close }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-else :property="v.key" :label="v.value" :key="i" width="100px"></el-table-column>
              </template>
            </el-table>
          </el-row>
        </div>
      </template>
    </el-drawer>
  </div>
</template>

<script>
import { URL_HANDLE_ACCOUNT, URL_GET_MONOTOR_ACCOUNT, URL_CHECK_TRADES } from 'api/api'
import { makeSound } from 'common/js/util'

const data = () => {
  return {
    tbodyData: [],
    accInfo: null,
    loadAccInfo: false,
    addAccWindow: false,
    ipTableWindow: false,
    keyword: '',
    allIps: [],
    filterIps: [],
    ipsData: [],
    ipPageNum: 1,
    ipPageSize: 5,
    ipTotal: 0,
    commentType: '',
    accForm: {
      login: null,
      comment: null,
    },
    pageNum: 1,
    pageSize: 5,
    total: 0,
    notify: false,
    notifyData: {},
    intervalId: null,
  }
}

const mixins = [require('common/mixin/base').base({ language: 'monitorAccounts' }), require('common/mixin/base').base({ reuse: 'reuse' })]

const computed = {
  accHead() {
    const redColorColumns = ['DEPOSIT_TODAY','WITHDRAWAL_TODAY','CLOSED_PL','TOTAL_FLOATING_PL','TOTAL_CLOSE_PL','TOTAL_PL']
    this.language.accHead.forEach(head => {
        if(redColorColumns.includes(head.key)) head.redColor = true;
    })
    return this.language.accHead
  },
  tableHead() {
    return this.language.tableHead
  },
  rules() {
    return this.language.rules
  },
  notifyCount() {
    return Object.keys(this.notifyData).reduce((p, c) => {
      if (this.notifyData[c] != null) return p + 1
      else return p
    }, 0)
  },
}

const created = function () {
  this.getAccount()
  this.checkTrades()
  this.intervalId = setInterval(this.checkTrades, 3e5)
}

const destroyed = function () {
  clearInterval(this.intervalId)
}

const methods = {
  refreshAcc() {
    this.pageNum = 1
    this.getAccount()
  },
  addAccount() {
    this.$refs.accForm.validate((valid) => {
      if (valid) {
        const createdBy = JSON.parse(sessionStorage.getItem('user') || '{}').name
        this.$http.post(URL_HANDLE_ACCOUNT, { handleType: 'i', createdBy, ...this.accForm }).then((res) => {
          const code = res.data.data
          if (code === 9000) {
            this.$message({ message: this.language.addSuccess, type: 'success' })
            this.getAccount()
          } else this.$message({ message: this.language.addFailed, type: 'error' })
          this.resetAccInfo()
        })
      }
    })
  },
  getAccount() {
    this.loadAccInfo = true
    this.$http.get(URL_GET_MONOTOR_ACCOUNT, { params: { pageNum: this.pageNum, pageSize: this.pageSize } }).then((res) => {
      const result = res.data.data
      this.total = result.count
      this.accInfo = result.rows
      this.loadAccInfo = false
    })
  },
  updateAccount(row) {
    const login = row.LOGIN
    const lg = this.language
    this.$confirm(`${lg.updateMsg1Txt}(${login})${lg.updateMsg2Txt}`, lg.notifyTxt, { confirmButtonText: lg.formConfirmTxt, cancelButtonText: lg.formCancelTxt, type: 'warning' }).then(() => {
      const body = {
        LOGIN: login,
        COMMENT_1: row.COMMENT_1 || null,
        COMMENT_2: row.COMMENT_2 || null,
        COMMENT_3: row.COMMENT_3 || null,
        COMMENT_4: row.COMMENT_4 || null,
        COMMENT_5: row.COMMENT_5 || null,
        handleType: 'u',
      }
      this.$http.post(URL_HANDLE_ACCOUNT, body).then((res) => {
        const code = res.data.data
        if (code == 9000) {
          this.$message({ message: lg.updateSuccess, type: 'success' })
          this.getAccount()
        } else {
          this.$message({ message: lg.updateFailed, type: 'info' })
        }
      })
    })
  },
  deleteAccount(login) {
    const lg = this.language
    this.$confirm(`${lg.deleteMsgTxt}(${login})`, lg.notifyTxt, { confirmButtonText: lg.formConfirmTxt, cancelButtonText: lg.formCancelTxt, type: 'warning' }).then(() => {
      this.$http.post(URL_HANDLE_ACCOUNT, { login, handleType: 'd' }).then((res) => {
        const code = res.data.data
        if (code == 9000) {
          this.$message({ message: lg.delSuccess, type: 'success' })
          this.getAccount()
        } else {
          this.$message({ message: lg.delFailed, type: 'info' })
        }
      })
    })
  },
  checkTrades() {
    const userTime = this.$moment()
    const tzOfMT4 = sessionStorage.getItem('MT4TimeZone') || 3
    const tzOfUser = userTime.utcOffset() / 60
    const mt4Time = userTime.add(tzOfMT4 - tzOfUser, 'h')
    const end = mt4Time.format('YYYY-MM-DD HH:mm'),
      hmOfEnd = mt4Time.format('HH:mm')
    mt4Time.subtract(5, 'minute')
    const start = mt4Time.format('YYYY-MM-DD HH:mm'),
      hmOfStart = mt4Time.format('HH:mm')
    this.$http.get(URL_CHECK_TRADES, { params: { start, end } }).then((res) => {
      const trades = res.data.data
      if (Array.isArray(trades) && trades.length !== 0) {
        makeSound()
        const tmpObj = {}
        tmpObj[`${hmOfStart} - ${hmOfEnd}`] = trades
        this.notifyData = Object.assign({}, this.notifyData, tmpObj)
      }
    })
  },
  resetAccInfo() {
    this.addAccWindow = false
    this.commentType = ''
    this.$refs.accForm.resetFields()
  },
  handlePageChange(val) {
    this.pageNum = val
    this.getAccount()
  },
  handleSizeChange(val) {
    this.pageNum = 1
    this.pageSize = val
    this.getAccount()
  },
  showTable(ipRelatedLogins) {
    this.ipTableWindow = true
    this.allIps = ipRelatedLogins || []
    this.ipTotal = ipRelatedLogins.length
    this.filterIps = this.allIps.filter((v) => true)
    this.ipsData = this.filterIps.slice(0, this.ipPageSize)
  },
  handleIPPageChange(val) {
    this.ipPageNum = val
    this.ipsData = this.filterIps.slice((val - 1) * this.ipPageSize, val * this.ipPageSize)
  },
  handleIPSizeChange(val) {
    this.ipPageNum = 1
    this.ipPageSize = val
    this.ipsData = this.filterIps.slice(0, val)
  },
  handleWindowClose() {
    this.keyword = ''
    this.ipPageNum = 1
    this.ipTotal = 0
    this.ipsData = []
    this.filterIps = []
    this.allIps = []
  },
  findByKeyword() {
    const kw = this.keyword
    this.filterIps = this.allIps.filter((data) => !kw || data.IP.includes(kw) || (data.RELATED_LOGINS || '').includes(kw))
    this.ipTotal = this.filterIps.length
    this.handleIPPageChange(1)
  },
  handleCommentChange(val) {
    this.$refs.accForm.clearValidate('comment')
    this.accForm.comment = val == 6 ? null : this.language.commentOpt[val]
  },
  export2Excel() {
    const header = this.language.ipTableHead
    require.ensure([], () => {
      const { export_json_to_excel } = require('@/vendor/Export2Excel')
      const tHeader = header.map((v) => v.value)
      const filterVal = header.map((v) => v.key)
      const data = this.filterIps.map((v) => filterVal.map((j) => v[j]))
      export_json_to_excel(tHeader, data, this.language.excelName)
    })
  },
  clearNotify(key) {
    this.notifyData[key] = null
  },
}

export default {
  data,
  mixins,
  computed,
  created,
  methods,
  destroyed,
}
</script>


// WEBPACK FOOTER //
// src/views/report/monitor-accounts-report.vue